var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62717 1.16971C9.9181 0.895781 10.3737 0.895781 10.6646 1.16971C12.6932 3.07968 15.4303 4.25001 18.444 4.25001C18.492 4.25001 18.5399 4.24972 18.5877 4.24913C18.9169 4.24506 19.2108 4.45381 19.3137 4.76482C19.7286 6.01958 19.9528 7.35954 19.9528 8.75006C19.9528 14.6921 15.865 19.683 10.3339 21.0983C10.2106 21.1299 10.0812 21.1299 9.95786 21.0983C4.42677 19.683 0.338989 14.6921 0.338989 8.75006C0.338989 7.35954 0.563163 6.01958 0.978113 4.76482C1.08096 4.45381 1.37484 4.24506 1.70412 4.24913C1.75192 4.24972 1.7998 4.25001 1.84774 4.25001C4.86147 4.25001 7.59864 3.07968 9.62717 1.16971ZM10.1459 7.25C10.5625 7.25 10.9003 7.58579 10.9003 8V11.75C10.9003 12.1642 10.5625 12.5 10.1459 12.5C9.72926 12.5 9.39152 12.1642 9.39152 11.75V8C9.39152 7.58579 9.72926 7.25 10.1459 7.25ZM10.1459 14C9.72926 14 9.39152 14.3358 9.39152 14.75V14.7575C9.39152 15.1717 9.72926 15.5075 10.1459 15.5075H10.1534C10.5701 15.5075 10.9078 15.1717 10.9078 14.7575V14.75C10.9078 14.3358 10.5701 14 10.1534 14H10.1459Z",
    fill: "#FFAA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.add25097ef34c1a487e59c4c8cdd42b5.svg";
export { ForwardRef as ReactComponent };